const d3 = Object.assign(
    {},
    require("d3-array"),
    require("d3-selection"),
    require("d3-fetch"),
    require("d3-transition"),
    require("d3-ease"),
    require("d3-brush"),
    require("d3-zoom"),
    require("d3-scale")
)

export default function drawBase() {
    d3.select("#d3-root").remove() // Cleaning for hot refresh

    this.wrapper = d3
        .select(`#${this.DOMtarget}`)
        .append("svg")
        .attr("width", this.dimensions.width)
        .attr("height", this.dimensions.height)
        .attr("x", 0)
        .attr("y", 0)
        .attr("class", "wrapper")
        .attr("id", "d3-root")

    this.wrapper
        .append("defs")
        .append("clipPath")
        .attr("id", "clip")
        .append("svg:rect")
        .attr("id", "clipRect")
        .attr("width", this.dimensions.boundedWidth)
        // .attr("height", this.dimensions.height)
        .attr("x", this.dimensions.margin.left)
        .attr("y", this.dimensions.margin.top)


    this.wrapper
        .append("defs")
        .append("clipPath")
        .attr("id", "clipWide")
        .append("svg:rect")
        .attr("id", "clipWideRect")
        .attr(
            "width",
            this.dimensions.boundedWidth + this.dimensions.margin.right
        )
        // .attr("height", this.dimensions.boundedHeight)
        .attr("x", this.dimensions.margin.left)
        .attr("y", this.dimensions.margin.top)
}
